import AutoCompleteDropdown from "components/autocomplete/AutoCompleteDropdown";
import Spinner from "components/spinner/Spinner";
import { displayNotification, generateOptionsFromData, sendAPIRequest } from "helpers";
import { useGetUsersByRoleIdQuery } from "modules/pvs_activities/redux/service/user";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const UserModal = ({ title, isShow, initModal, roleId, reloadData, defaultValue }) => {

    const { t } = useTranslation();
    const [form, setForm] = useState({ id: '' });
    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const userRes = useGetUsersByRoleIdQuery({ role_id: roleId, is_status: 1 });

    const handlePopupValueChange = (val) => {
        setForm({ id: val || '' });
    };
    useEffect(() => {
        if (isShow) {
            setForm({ id: defaultValue || '' });
        }
    }, [isShow, defaultValue]);

    const userOptions = useMemo(() => {
        if (userRes && userRes.data && Array.isArray(userRes.data) && userRes.data.length > 0) {
            const updatedData = userRes.data.map(user => ({
                ...user,
                display_name: `${user.name} (${user.email})`
            }));
            if (userRes.isSuccess) return generateOptionsFromData(updatedData, {
                value: "id",
                label: "display_name",
            });
        }
        return [];
    }, [userRes]);

    const handleSave = async () => {
        if (form.id === '') {
            displayNotification("error", `${t("-1", "Please Select values")}`);
        }
        else {
            try {
                setIsBtnLoading(true);
                reloadData(form);
                setIsBtnLoading(false);
                initModal();
            } catch (e) {
                setIsBtnLoading(false);
                console.log(e);
                displayNotification("error", "Failed to change mission delegate");
            }
        }
    };

    return (
        <Modal show={isShow} onHide={() => initModal()}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AutoCompleteDropdown
                    showClearIcon={false}
                    error={false}
                    required={false}
                    multiple={false}
                    label={title}
                    hasselectall={false}
                    options={userOptions}
                    onChange={(event, value) => {
                        handlePopupValueChange(value.value);
                    }}
                    value={userOptions.find((r) => r.value == form.id) ?? null}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="dark" onClick={handleSave}>
                    {isBtnLoading ? (
                        <Spinner message="Saving..." />
                    ) : (
                        <>
                            {" "}
                            <i className="fa-sharp fa-solid fa-check"></i>
                            {t("85", "Save")}
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

UserModal.defaultProps = {
    isShow: false,
    initModal: () => { },
    roleId: '',
    reloadData: () => { },
    defaultValue: '',
};

export default UserModal;
